import GenericPageController, { getServerSideProps } from './[...slug]'

export default GenericPageController

export { getServerSideProps }
